import { StatusNameCell } from './status-name-cell';

export const CustomNameRenderer = StatusNameCell;
